// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DatabaseTwoToneSvg from "@ant-design/icons-svg/es/asn/DatabaseTwoTone";
import AntdIcon from '../components/AntdIcon';

var DatabaseTwoTone = function DatabaseTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseTwoToneSvg
  }));
};

DatabaseTwoTone.displayName = 'DatabaseTwoTone';
export default React.forwardRef(DatabaseTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DatabaseTwoTone.js
// module id = 915
// module chunks = 0